import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  IconButton,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import ExportButton from "../../components/ag grid/ExportButton";
import DocumentViewController from "../../redux/actions/DocumentApiAction";
import "../../styles/styles.css";
import "../../styles/layout.css";

const DocumentList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  // Actions
  const { getEmployeeForGenrateDocument,getInternshipLetter} = DocumentViewController();

  // Redux state
  const {all_employee } = useSelector((state) => state.document);

  // Filters
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedRows, setSelectedRows] = useState([]);

  // Fetch employees on mount
  useEffect(() => {
    dispatch(getEmployeeForGenrateDocument());
  }, []);

  // Filter employees based on is_active status
  const filteredEmployees =
    selectedStatus === "all"
      ? all_employee
      : all_employee?.filter((e) =>
          selectedStatus === "active" ? e.is_active : !e.is_active
        );

  // Grid columns
  const columnDefs = [
  {
    headerCheckboxSelection: true,
    checkboxSelection: true,
    maxWidth: 50,
    pinned: "left",
  },
  {
    headerName: "SR.No",
    valueGetter: (params) => params.node.rowIndex + 1,
    maxWidth: 80,
  },
  { headerName: "Employee ID", field: "employee_id", flex: 0.8 },
  { headerName: "Name", valueGetter: p => `${p.data.first_name} ${p.data.last_name}` },
  {
    headerName: "Internship",
    flex: 1.2,
    cellRenderer: (params) => (
      <Tooltip title="Download Internship Letter">
        <IconButton
          color="primary"
          onClick={() => dispatch(getInternshipLetter(params.data.id,
            params.data.first_name,
            params.data.last_name
          ))}
        >
          <DownloadIcon />
        </IconButton>
      </Tooltip>
    ),
  },
  { headerName: "Joining", flex: 1 },
  { headerName: "Relieving", flex: 1.5 },
  { headerName: "Experience", flex: 1.5 },
];


  return (
    <div>
      {/* Export button */}
      <div className="d-flex justify-content-between mb-2">
        {selectedRows.length > 0 ? (
          <ExportButton
            gridRef={gridRef}
            selectedRows={selectedRows}
            fileName={`Employees_${new Date().toISOString().slice(0, 10)}.csv`}
            exportColumns={[
              "employee_id",
              "first_name",
              "last_name",
              "email",
              "mobile_number",
              "gender",
              "is_active",
            ]}
          />
        ) : (
          <div />
        )}
      </div>

      {/* Filters + Title */}
      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Employee Documents</h3>
          </Col> 
        </Row>
      </div>

      {/* Grid */}
      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={filteredEmployees}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>
    </div>
  );
};

export default DocumentList;
